// src/firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDDXVfe33eUvqvrM1wGng7blEvUPRWZYgo",
  authDomain: "bagdaconnect.firebaseapp.com",
  projectId: "bagdaconnect",
  storageBucket: "bagdaconnect.firebasestorage.app",
  messagingSenderId: "55898977074",
  appId: "1:55898977074:web:266eb2ae538ccfeba5dd2b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export the services you'll need
export const db = getDatabase(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);